import { Stack } from '@mui/material';
import { Control, Controller, FieldError, FieldValues } from 'react-hook-form';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { MuiTelInput } from 'mui-tel-input';
import TextFormLabel from '../text/TextFormLabel';
import { useLocalization } from 'localization';
import TextFormError from '../text/TextFormError';

export interface PhoneInputProps<T extends FieldValues = FieldValues> {
  name: string;
  required?: boolean;
  label?: string;
  disabled?: boolean;
  control: Control<T>;
}

const InputPhoneNumber = <T extends FieldValues = FieldValues>(props: PhoneInputProps<T>) => {
  const { t } = useLocalization();

  const { name, required = true, control, label, disabled = false } = props;

  return (
    <Controller
      control={control}
      name={name as any}
      render={({ field, fieldState: { error } }) => {
        const { onChange, value } = field;

        const phone = parsePhoneNumberFromString(value || '');
        const isValid = phone?.isValid() && phone?.isPossible();

        const phoneError: FieldError | undefined = {
          ...error,
          type: 'minLength',
          message: t('validation.mixed.default'),
        };
        return (
          <Stack spacing={0.5}>
            <TextFormLabel label={label ?? t('common.terms.phone')} required={required} />
            <MuiTelInput
              value={value}
              disabled={disabled}
              forceCallingCode
              onChange={newVal => onChange(newVal)}
              defaultCountry="DK"
              error={!!error}
              size="small"
            />
            {!!error && !isValid ? <TextFormError error={phoneError} /> : null}
          </Stack>
        );
      }}
    />
  );
};

export default InputPhoneNumber;
